function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_335",
  "data-name": "Group 335",
  transform: "translate(11.377)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_22",
  "data-name": "Path 22",
  d: "M60.036,2.421l-1.6,1.528A4.909,4.909,0,0,0,54.77,2.233a3.935,3.935,0,0,0-2.891,1.175A3.989,3.989,0,0,0,50.7,6.323a4.3,4.3,0,0,0,.517,2.139A3.837,3.837,0,0,0,52.7,9.92a4.29,4.29,0,0,0,2.116.541,4.161,4.161,0,0,0,1.81-.376,6.852,6.852,0,0,0,1.81-1.363l1.551,1.622a8.769,8.769,0,0,1-2.515,1.81,7.015,7.015,0,0,1-2.7.494,6.2,6.2,0,0,1-4.584-1.787A6.109,6.109,0,0,1,48.4,6.3a6.283,6.283,0,0,1,.823-3.2A5.975,5.975,0,0,1,51.55.846,6.488,6.488,0,0,1,54.794,0a6.967,6.967,0,0,1,5.242,2.421Z",
  transform: "translate(-48.4)"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_336",
  "data-name": "Group 336",
  transform: "translate(25.129 0.306)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_23",
  "data-name": "Path 23",
  d: "M106.9,1.3h2.421a8.173,8.173,0,0,1,2.844.353,2.991,2.991,0,0,1,1.363,1.175,3.506,3.506,0,0,1,.517,1.951,3.272,3.272,0,0,1-.564,1.975,3.25,3.25,0,0,1-1.716,1.2l2.844,5.36H112.1l-2.7-5.1h-.212v5.1H106.9ZM109.18,6h.705a2.863,2.863,0,0,0,1.5-.282,1.05,1.05,0,0,0,.4-.94,1.12,1.12,0,0,0-.212-.682,1.359,1.359,0,0,0-.541-.423,3.881,3.881,0,0,0-1.246-.118h-.635V6Z",
  transform: "translate(-106.9 -1.3)"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Group_337",
  "data-name": "Group 337",
  transform: "translate(34.696 0.306)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_24",
  "data-name": "Path 24",
  d: "M147.6,1.3h6.558V3.533H149.88V5.719h4.278v2.21H149.88V11.1h4.278v2.257H147.6Z",
  transform: "translate(-147.6 -1.3)"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Group_338",
  "data-name": "Group 338",
  transform: "translate(43.394 0.306)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_25",
  "data-name": "Path 25",
  d: "M184.624,1.3h2.7a8.84,8.84,0,0,1,3.9.658,4.911,4.911,0,0,1,2.092,2.116,6.965,6.965,0,0,1,.823,3.409,7,7,0,0,1-.47,2.562,5.3,5.3,0,0,1-1.269,1.928,4.32,4.32,0,0,1-1.763,1.058,12.759,12.759,0,0,1-3.291.306H184.6V1.3Zm2.257,2.21V11.1h1.058a5.474,5.474,0,0,0,2.28-.353,2.658,2.658,0,0,0,1.152-1.222,4.371,4.371,0,0,0,.447-2.092,3.924,3.924,0,0,0-1.081-2.962,4.263,4.263,0,0,0-3.1-.94h-.752Z",
  transform: "translate(-184.6 -1.3)"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Group_339",
  "data-name": "Group 339",
  transform: "translate(55.053 0.306)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_26",
  "data-name": "Path 26",
  d: "M234.2,1.3h1.2V13.336h-1.2Z",
  transform: "translate(-234.2 -1.3)"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "Group_340",
  "data-name": "Group 340",
  transform: "translate(58.015 0.306)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_27",
  "data-name": "Path 27",
  d: "M246.8,2.475V1.3h6.582V2.475H250.7v10.86H249.48V2.475Z",
  transform: "translate(-246.8 -1.3)"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "Group_341",
  "data-name": "Group 341",
  transform: "translate(0 2.656)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_28",
  "data-name": "Path 28",
  d: "M5.947,15.954l.729.376a3.892,3.892,0,0,1-.823,1.128,3.085,3.085,0,0,1-1.058.658,3.86,3.86,0,0,1-1.316.235A3.174,3.174,0,0,1,.917,17.271,3.577,3.577,0,0,1,0,14.85a3.665,3.665,0,0,1,.776-2.28A3.2,3.2,0,0,1,3.432,11.3a3.289,3.289,0,0,1,2.727,1.293,3.491,3.491,0,0,1,.729,2.28H.893a2.682,2.682,0,0,0,.752,1.9,2.4,2.4,0,0,0,1.787.752,2.832,2.832,0,0,0,.987-.188,2.791,2.791,0,0,0,.823-.47A2.929,2.929,0,0,0,5.947,15.954Zm0-1.787a3.013,3.013,0,0,0-.494-1.1,2.249,2.249,0,0,0-.87-.658,2.646,2.646,0,0,0-1.128-.259,2.443,2.443,0,0,0-1.693.635,2.728,2.728,0,0,0-.776,1.387Z",
  transform: "translate(0 -11.3)"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  id: "Group_342",
  "data-name": "Group 342",
  transform: "translate(7.546 4.795)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_29",
  "data-name": "Path 29",
  d: "M33.393,20.4a1.242,1.242,0,0,1,.917.376,1.191,1.191,0,0,1,.376.893,1.242,1.242,0,0,1-.376.917,1.206,1.206,0,0,1-.917.376A1.284,1.284,0,0,1,32.1,21.669a1.156,1.156,0,0,1,.376-.893A1.242,1.242,0,0,1,33.393,20.4Z",
  transform: "translate(-32.1 -20.4)"
}));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_427",
    "data-name": "Group 427",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.597,
    height: 12.647,
    viewBox: "0 0 64.597 12.647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.16478225.svg";
export { ForwardRef as ReactComponent };